import React from 'react';
import styled from 'styled-components';
import { useForm, Controller } from 'react-hook-form';
import CustomInput from '../Inputs/CustomInput';
import SubmitButton from '../Buttons/SubmitButton';
import useTiposIdentificacion from '../../hooks/parameter/useTiposIdentificacion';
import CustomSelect from '../Inputs/CustomSelect';

// ##### Estilos #####
const Container = styled.div`
  position: relative;
  width: 100% !important;
`;

const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 2rem;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const InputContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 50vw;

  @media (max-width: 1080px) {
    width: 70vw;
  }

  @media (max-width: 900px) {
    width: 80vw;
  }

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    width: 90%;
  }
`;

export const ConsultaPQR = () => {
  const { handleSubmit, control } = useForm({ mode: 'onBlur' });
  const { tiposIdentificacion } = useTiposIdentificacion();

  const onSubmit = async (data) => {

  };

  return (
    <Container>
      <FormContainer onSubmit={handleSubmit(onSubmit)}>
        <InputContainer>
          <Controller
            name='tipoDocumento'
            control={control}
            rules={{ required: 'El tipo de documento es requerido' }}
            render={({
              field: { value, onBlur, onChange },
              fieldState: { error },
            }) => (
              <CustomSelect
                value={value}
                onChange={onChange}
                onBlut={onBlur}
                label='Tipo de documento *'
                width='90%'
                error={error}
                data={tiposIdentificacion.map((item) => {
                  return { name: item.docName, value: JSON.stringify(item) };
                })}
              />
            )}
          />

          <Controller
            name='DocNumero'
            control={control}
            rules={{ required: 'El número de documento es requerido' }}
            render={({
              field: { value, onBlur, onChange },
              fieldState: { error },
            }) => (
              <CustomInput
                value={value}
                onChange={onChange}
                onBlut={onBlur}
                label='Número de documento *'
                width='100%'
                error={error}
                type='number'
              />
            )}
          />
        </InputContainer>

        <InputContainer>
          <Controller
            name='numRadicado'
            control={control}
            rules={{ required: 'El número de documento es requerido' }}
            render={({
              field: { value, onBlur, onChange },
              fieldState: { error },
            }) => (
              <CustomInput
                value={value}
                onChange={onChange}
                onBlut={onBlur}
                label='Número de Radicado *'
                width='100%'
                error={error}
                type='number'
              />
            )}
          />
        </InputContainer>

        <SubmitButton label='Buscar' />
      </FormContainer>
    </Container>
  );
};
